fragment PeepLegacyIdFragment on Peep {
    id
    legacyId
    shouldShowLegacyId
}
